import { Tag, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  isPublic: boolean
}
export const PublicTag = ({ isPublic }: Props) => {
  const [open, toggle] = useToggle()

  const publicLabel = i18n.t('performance_goals.public_tag.public.label')
  const restrictedLabel = i18n.t('performance_goals.public_tag.restricted.label')
  const publicDescription = i18n.t('performance_goals.public_tag.public.description')
  const restrictedDescription = i18n.t('performance_goals.public_tag.restricted.description')

  return (
    <Tooltip.Alt
      attachment="top center"
      label={isPublic ? publicDescription : restrictedDescription}
      open={open}
      toggle={toggle}
    >
      <Tag type={isPublic ? 'viridian' : 'grey'} size="normal" inline>
        {isPublic ? publicLabel : restrictedLabel}
      </Tag>
    </Tooltip.Alt>
  )
}
